import MaterialInput from './MaterialInput'

function Input() {
  return null
}

Input.Material = MaterialInput

export default Input
